module.exports = __webpack_public_path__ + "img/browser_icon.c40a643d.png";